<template>
  <div>
    <div v-show="!error">
      <h5 class="my-4">My Sign Ups</h5>
      <div class="row" v-for="s in signups">
        <div class="card my-3 col-xs-12 col-md-4 offset-md-4">
          <div class="row no-gutters">
            <div class="col-md-4">
              <img :src="'images/'+s.ministryRole.avatar" class="card-img">
            </div>
            <div class="col-md-8">
              <div class="card-body">
                <h5 class="card-title">{{s.ministryRole.name}}</h5>
                <p class="card-text">{{s.ministryRole.description}}</p>
                <p class="card-text">
                  <small class="font-weight-bold">
                      <span v-show="s.status !== 'Rejected by Leader' && s.status !== 'Rejected by Ministry'">{{s.status}}</span>
                      <span v-show="s.status === 'Rejected by Leader'">Speak to your Pastoral Leader on your Status</span>
                      <span v-show="s.status === 'Rejected by Ministry'">Ministry Leader will contact you on your Status</span>
                  </small>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="error">
      <br>
      <br>
      <p>No sign ups found</p>
    </div>
    <div>For enquiries, email to <a href="mailto:contribute@hopesingapore.org.sg">contribute@hopesingapore.org.sg</a></div>
    <br><br><br>
  </div>
</template>

<script>
import http from "../commons/http.js";
export default {
  data: function() {
    return {
      signups: [],
      error: false,
      host: http.host
    };
  },
  methods: {
    getSignUps: async function() {
      var id = this.$route.query.id;
      try {
        let response = await http.get("/ministryrequest/candidate/" + id);
        if (response.data.length > 0) {
          this.signups = response.data;
          this.signups.forEach(s => {
            if (s.directMessage == null) {
              s.directMessage = {
                status: "processing",
                uuid:''
              };
            }
          });
        } else {
          this.error = true;
        }
      } catch (err) {
        this.error = true;
      }
    },
    rsvp: function(id){
        this.$router.push('/directmessageresponse?id='+id);
    }
  },
  beforeMount: function() {
    this.getSignUps();
  }
};
</script>

<style>
</style>
